import { initializeMenu, initializeMenuScroll, initializeMobileMenu, initializeSearch } from './menu/index'
import { initializeAnchors, initializeSidemenu, addDotsForTargets } from './sidemenu'
import initializeFiles from './files'
import initializeMap from './mapblock'
import initializeCarousel from './carousel'
import initializeTopText from './top-text'

import './twitter'

addEventListener('DOMContentLoaded', (event) => {
    if (/(Android|iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
        initializeMobileMenu()
    }

    // Menu.
    initializeMenu()
    initializeSearch()
    
    // Scroll related.
    initializeMenuScroll()
    
    // Sidemenu.
    addDotsForTargets()
    initializeAnchors()
    initializeSidemenu()
    
    // Other components.
    initializeCarousel()
    // initializeFiles() not available yet
    initializeMap()
    initializeTopText()
})